import { execOnLoad } from '@general/helpers';
import './slideshow.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSlideshow = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const slideshow = sectionContainer.querySelector('.slideshow__container');
  if (!slideshow) return;

  const autoplaySpeed = parseFloat(slideshow?.dataset?.autoplaySpeed);
  const prevArrow = slideshow.querySelector('.slideshow__arrow--left');
  const nextArrow = slideshow.querySelector('.slideshow__arrow--right');
  const pagination = slideshow.querySelector('.slideshow__pagination');

  const options = {
    loop:
      slideshow.classList.contains('slideshow__container--loop') &&
      slideshow.querySelectorAll('.swiper-slide').length >= 2,
    modules: [
      ...(!isNaN(autoplaySpeed) && autoplaySpeed > 0 ? [Autoplay] : []),
      ...(prevArrow && nextArrow ? [Navigation] : []),
      ...(pagination ? [Pagination] : []),
    ],
    ...(!isNaN(autoplaySpeed) && autoplaySpeed > 0
      ? {
          autoplay: {
            enabled: true,
            delay: autoplaySpeed * 1000,
            disableOnInteraction: true,
          },
        }
      : {}),
    ...(prevArrow && nextArrow
      ? {
          navigation: {
            prevEl: prevArrow,
            nextEl: nextArrow,
          },
        }
      : {}),
    ...(pagination
      ? {
          pagination: {
            el: pagination,
            clickable: true,
          },
        }
      : {}),
  };

  new Swiper(slideshow, options);
};

execOnLoad(window.dAgency.initSlideshow, '.slideshow__section');
